module.exports = __webpack_public_path__ + "img/car-dark-grey.4d18ea2a.svg";